import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export const AddExpenseDialog = ({ open, onClose, onSave, editingExpense }) => {
  const [formData, setFormData] = useState({
    title: "",
    amount: "",
    category: "equipment",
    date: new Date().toISOString().split('T')[0],
    description: "",
  });

  // Update form when editing expense changes
  useEffect(() => {
    if (editingExpense) {
      setFormData({
        title: editingExpense.title || "",
        amount: editingExpense.amount || "",
        category: editingExpense.category || "equipment",
        date: editingExpense.date || new Date().toISOString().split('T')[0],
        description: editingExpense.description || "",
      });
    } else {
      setFormData({
        title: "",
        amount: "",
        category: "equipment",
        date: new Date().toISOString().split('T')[0],
        description: "",
      });
    }
  }, [editingExpense, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.title || !formData.amount || !formData.date) {
      toast.error("Veuillez remplir tous les champs obligatoires");
      return;
    }

    onSave(formData);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-rose-600">
            {editingExpense ? "Modifier" : "Ajouter"} une Charge
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="sm:col-span-2">
              <Label htmlFor="title">Titre de la charge *</Label>
              <Input
                id="title"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                placeholder="Ex: Achat matériel, Essence, Publicité..."
                required
              />
            </div>

            <div>
              <Label htmlFor="amount">Montant (€) *</Label>
              <Input
                id="amount"
                type="number"
                step="0.01"
                value={formData.amount}
                onChange={(e) => setFormData({ ...formData, amount: parseFloat(e.target.value) })}
                placeholder="0.00"
                required
              />
            </div>

            <div>
              <Label htmlFor="date">Date *</Label>
              <Input
                id="date"
                type="date"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                required
              />
            </div>

            <div className="sm:col-span-2">
              <Label htmlFor="category">Catégorie *</Label>
              <select
                id="category"
                value={formData.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                className="w-full h-10 px-3 py-2 border border-gray-300 rounded-md"
                required
              >
                <option value="equipment">Équipement</option>
                <option value="transport">Transport / Essence</option>
                <option value="marketing">Marketing / Publicité</option>
                <option value="maintenance">Maintenance / Réparation</option>
                <option value="other">Autre</option>
              </select>
            </div>

            <div className="sm:col-span-2">
              <Label htmlFor="description">Description (optionnel)</Label>
              <Textarea
                id="description"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                placeholder="Détails supplémentaires..."
                rows={3}
                className="resize-none"
              />
            </div>
          </div>

          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" onClick={onClose}>
              Annuler
            </Button>
            <Button type="submit" className="bg-gradient-to-r from-rose-500 to-pink-500">
              {editingExpense ? "Modifier" : "Ajouter"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
